import Animations from '../lib/animations';

export default class HomeComponent {
  static CLASSES = {
    HOME: 'home',
    INTRO: 'home__intro',
    INTRO_SHIP_1: 'home__intro__ship-1',
    INTRO_SHIP_2: 'home__intro__ship-2',
    INTRO_SHIP_3: 'home__intro__ship-3',
    ANIMATED: 'is-animated'
  };

  static init($home) {
    if (!$home || $home.homeComponent) {
      return;
    }

    $home.homeComponent = new HomeComponent($home);
  }

  static initAll() {
    document.querySelectorAll(`.${HomeComponent.CLASSES.HOME}`).forEach(($home) => {
      HomeComponent.init($home);
    });
  }

  constructor($home) {
    this.$home = $home;
    this.$intro = $home.querySelector(`.${HomeComponent.CLASSES.INTRO}`);
    this.$introShip1 = $home.querySelector(`.${HomeComponent.CLASSES.INTRO_SHIP_1}`);
    this.$introShip2 = $home.querySelector(`.${HomeComponent.CLASSES.INTRO_SHIP_2}`);
    this.$introShip3 = $home.querySelector(`.${HomeComponent.CLASSES.INTRO_SHIP_3}`);

    this.intersectEntry = this.intersectEntry.bind(this);

    this.init();
  }

  init() {
    this.observer = new IntersectionObserver((entries) => {
      entries.forEach(this.intersectEntry);
    });

    this.observer.observe(this.$intro);

    Animations.init({
      // нужно указывать размерность для всех изменяющихся значений `from`
      // для цветов rgb(a)
      map: {
        children: {
          'cloud-1': {
            from: {
              transform: 'translate3d(-12.073%, 0, 0)'
            },
            to: {
              transform: 'translate3d(0, 0, 0)'
            },
            speed: 1
          },
          'cloud-2': {
            from: {
              transform: 'translate3d(-50%, 0, 0)'
            },
            to: {
              transform: 'translate3d(0, 0, 0)'
            },
            speed: 1
          }
        }
      },

      // Инфографика
      infographics: {
        from: {
          transform: 'translate3d(0, 8%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 1
      },
      'cloud-3': {
        from: {
          transform: 'translate3d(0, 8%, 0) scaleX(-1)'
        },
        to: {
          transform: 'translate3d(0, 0, 0) scaleX(-1)'
        },
        speed: 1
      },
      dolphin: {
        from: {
          transform: 'translate3d(-2.322%, 1.653%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      ship: {
        from: {
          transform: 'translate3d(5.6%, 1.46%, 0) rotate(2deg)'
        },
        to: {
          transform: 'translate3d(0, 0, 0) rotate(0deg)'
        },
        speed: 2
      },
      submarine: {
        from: {
          transform: 'translate3d(5.068%, 6.593%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      diver: {
        from: {
          transform: 'translate3d(-4.785%, -3.289%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      'gondola-1': {
        from: {
          transform: 'translate3d(-26.786%, -1.923%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      'gondola-2': {
        from: {
          transform: 'translate3d(-26.786%, -1.923%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },
      airship: {
        from: {
          transform: 'translate3d(-8%, 5%, 0)'
        },
        to: {
          transform: 'translate3d(0, 0, 0)'
        },
        speed: 2
      },

      // Видео
      video: {
        from: {
          transform: 'translate3d(0, 20vw, 0)',
          opacity: 0
        },
        to: {
          transform: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        speed: 2
      },

      //Мнения
      opinions: {
        from: {
          transform: 'translate3d(0, 20vw, 0)',
          opacity: 0
        },
        to: {
          transform: 'translate3d(0, 0, 0)',
          opacity: 1
        },
        speed: 2
      }
    });
  }

  destroy() {
    this.observer.disconnect();
    this.$home.homeComponent = null;
  }

  intersectEntry(entry) {
    this.$introShip1.classList.toggle(HomeComponent.CLASSES.ANIMATED, entry.isIntersecting);
    this.$introShip2.classList.toggle(HomeComponent.CLASSES.ANIMATED, entry.isIntersecting);
    this.$introShip3.classList.toggle(HomeComponent.CLASSES.ANIMATED, entry.isIntersecting);
  }
}
